// Declared twice so that docs appear when selecting colors
export interface GammaPalette extends Record<string, string> {
  /** **#EBE5F2** Purple */
  readonly gamma10: string;
  /** **#DDD0EA** Purple */
  readonly gamma30: string;
  /** **#C1A7D9** Purple */
  readonly gamma60: string;
  /** **#9B70C4** Purple */
  readonly gammaPrimary: string;
  /** **#633093** Purple */
  readonly gamma80: string;
  /** **#390D62** Purple */
  readonly gamma90: string;
}

export const gammaPalette: GammaPalette = {
  gamma10: '#EBE5F2',
  gamma30: '#DDD0EA',
  gamma60: '#C1A7D9',
  gammaPrimary: '#9B70C4',
  gamma80: '#633093',
  gamma90: '#390D62',
};
